export const onMount = "omMount";
export const addRule  = "addRule";
export const getTypeOption = "getTypeOption";
export const storeProductId = "storeProductId";
export const clearCreateRuleData = "clearCreateRuleData";
export const setCreateRuleChanges = "setCreateRuleChanges";
export const setCreateCohortChanges = "setCreateCohortChanges";
export const resetCreateRuleData = "resetCreateRuleData"